module.exports = __webpack_public_path__ + "img/86.81beb689.jpg";